{
  "tabs": {
    "chat": "Gesels",
    "reminders": "Herinneringe",
    "calendar": "Kalender",
    "settings": "Instellings"
  },
  "common": {
    "cancel": "Kanselleer",
    "save": "Stoor",
    "confirm": "Bevestig",
    "delete": "Verwyder",
    "back": "Terug",
    "close": "Sluit",
    "edit": "Wysig",
    "search": "Soek",
    "all": "Almal",
    "loading": "Laai...",
    "error": "Iets het verkeerd geloop",
    "notFound": "Nie gevind nie",
    "tryAgain": "Probeer asseblief weer",
    "retry": "Probeer weer",
    "undo": "Maak ongedaan",
    "pullToRefresh": "Trekkie om te herlaai",
    "justNow": "net nou"
  },
  "auth": {
    "welcome": "Welkom by FishMemory",
    "tagline": "Jou WhatsApp herinneringsassistent, nou in jou sak.",
    "subtitle": "Jou WhatsApp herinneringsassistent, nou in jou sak.",
    "phoneLabel": "Jou WhatsApp nommer",
    "phoneHint": "Ons stuur 'n verifikasiekode via WhatsApp",
    "invalidPhone": "Voer asseblief 'n geldige telefoonnommer in",
    "continue": "Gaan voort",
    "enterPhone": "Voer jou WhatsApp nommer in",
    "phonePlaceholder": "Telefoonnommer",
    "sendCode": "Stuur kode",
    "verifyTitle": "Verifieer jou nommer",
    "otpSentTo": "‘n 6-syfer kode is gestuur na {{phone}} via WhatsApp",
    "enterFullCode": "Voer asseblief al 6 syfers in",
    "invalidOtp": "Ongeldige kode. Probeer asseblief weer.",
    "otpFailed": "Kon nie kode stuur nie. Probeer weer.",
    "otpResent": "Kode weer gestuur",
    "resendIn": "Herstuur oor {{seconds}}s",
    "resendCode": "Herstuur kode",
    "enterOtp": "Voer die kode in wat na jou WhatsApp gestuur is",
    "verify": "Verifieer",
    "resend": "Herstuur kode",
    "wrongNumber": "Verkeerde nommer?",
    "backToPhone": "Terug na nommer",
    "editPhone": "Wysig telefoonnommer",
    "error": "Fout",
    "setupTitle": "Kom ons stel dit op",
    "setupSubtitle": "Jy kan dit later altyd in Instellings verander",
    "namePlaceholder": "Jou naam",
    "letsGo": "Voltooi opstelling",
    "skipForNow": "Slaan oor vir nou"
  },
  "chat": {
    "title": "FishMemory",
    "placeholder": "Tik 'n boodskap...",
    "inputPlaceholder": "Tik 'n boodskap...",
    "typing": "FishMemory tik...",
    "online": "Aanlyn",
    "connecting": "Verbind...",
    "reconnecting": "Herverbind...",
    "offline": "Aflyn",
    "empty": "Begin 'n gesprek",
    "emptyHint": "Skep herinneringe, kyk jou skedule na, of vra vir hulp.",
    "emptyAction": "Stuur 'n voorbeeldherinnering",
    "actions": "Geselsaksies",
    "keep": "Hou boodskappe",
    "clearTitle": "Maak gesels oop",
    "clearConfirm": "Verwyder alle boodskappe van hierdie toestel? Dit kan nie ongedaan gemaak word nie.",
    "clear": "Maak gesels oop",
    "optionSelected": "Geselekteer: {{label}}",
    "sendingSelection": "Stuur...",
    "connectionLost": "Herverbind..."
  },
  "reminders": {
    "title": "My Herinneringe",
    "active": "Aktief",
    "today": "Vandag",
    "thisWeek": "Hierdie Week",
    "history": "Geskiedenis",
    "items": "items",
    "emptyTitle": "Nog geen herinneringe nie",
    "emptySubtitle": "Skep een in gesels en dit sal hier verskyn.",
    "emptyAction": "Maak gesels oop",
    "filterActive": "Aktief",
    "filterToday": "Vandag",
    "filterWeek": "Hierdie Week",
    "filterHistory": "Geskiedenis",
    "emptyState": "Nog geen herinneringe nie. Begin gesels!",
    "swipeDone": "Gedoen",
    "swipeSnooze": "Slaap",
    "swipeDelete": "Verwyder",
    "search": "Soek herinneringe...",
    "upcoming": "Komend",
    "completed": "Voltooi",
    "overdue": "Agterstallig",
    "tomorrow": "Môre",
    "synced": "Gesinkroniseer {{value}}",
    "swipeHint": "Veeg 'n herinnering vir meer aksies",
    "noResults": "Geen herinneringe pas by jou soektog nie",
    "noResultsHint": "Probeer 'n ander sleutelwoord of maak die soektog skoon",
    "deleteAllFailed": "Kon nie alle herinneringe verwyder nie"
  },
  "calendar": {
    "title": "Kalender",
    "today": "Vandag",
    "tomorrow": "Môre",
    "completed": "gedoen",
    "noEvents": "Niks geskeduleer nie",
    "noEventsSubtitle": "Kies 'n datum om herinneringe en kalendergebeurtenisse te sien.",
    "googleEvent": "Google Kalender",
    "legendActive": "Aktief",
    "legendRecurring": "Herhalend",
    "legendDone": "Gedoen",
    "legendGoogle": "Google",
    "previousMonth": "Vorige maand",
    "nextMonth": "Volgende maand",
    "previousYear": "Vorige jaar",
    "nextYear": "Volgende jaar",
    "goToToday": "Gaan na vandag",
    "all": "Almal",
    "active": "Aktief",
    "done": "Gedoen",
    "paused": "Gepouseer"
  },
  "settings": {
    "title": "Instellings",
    "profile": "Profiel",
    "name": "Vertoonnaam",
    "enterName": "Voer jou naam in",
    "language": "Taal",
    "uiLanguage": "App-taal",
    "uiLanguageHelp": "Verander die app-koppelvlak, kalenderetikette en uitlegrigting net op hierdie toestel.",
    "serverLanguage": "Geselstaal",
    "serverLanguageHelp": "Verander die taal wat deur bedienerantwoorde en herinneringsboodskappe vir jou rekening gebruik word.",
    "timezone": "Tydsone",
    "currentTimezone": "Huidige tydsone",
    "timezoneHelp": "Alle herinneringstye word in hierdie tydsone vertoon.",
    "timezonePlaceholder": "America/New_York",
    "timezoneSave": "Stoor tydsone",
    "timezoneSaved": "Tydsone opgedateer",
    "detect": "Detect",
    "detectFailed": "Kon nie tydsone opspoor nie",
    "autoDetect": "Outomaties opspoor via GPS",
    "notifications": "Kennisgewings",
    "notificationsHelp": "Opvolgherinneringe beheer herhaalde waarskuwings nadat 'n herinnering afgelewer is. Toestelvlak kennisgewingstoestemmings word steeds in jou fooninstellings bestuur.",
    "pushEnabled": "Stootkennisgewings",
    "autoDoneOnFire": "Merk outomaties as voltooi wanneer geaktiveer",
    "autoDoneOnFireDesc": "As dit af is, bly herinneringe aktief totdat jy dit voltooi merk.",
    "googleCalendar": "Google Kalender",
    "google": "Google Kalender",
    "googleConnected": "Gekoppel",
    "googleDisconnected": "Nie gekoppel nie",
    "googleConnectedHelp": "Nuwe herinneringe kan outomaties met jou kalender gesinkroniseer word.",
    "googleDisconnectedHelp": "Koppel Google Kalender om herinneringe en gebeure te sinkroniseer.",
    "googleConnectFailed": "Kon nie Google Kalender koppel nie",
    "connected": "Gekoppel",
    "disconnected": "Nie gekoppel nie",
    "connect": "Koppel",
    "disconnect": "Ontkoppel",
    "autoSync": "Outomatiese sinkronisering van nuwe herinneringe",
    "autosync": "Outomatiese sinkronisering van nuwe herinneringe",
    "subscription": "Intekening",
    "trialUsed": "Proeflopie: {{used}}/{{total}} gebruik",
    "trialStatus": "Proeflopie beskikbaar",
    "activeStatus": "Aktiewe intekening",
    "expiredStatus": "Intekening verval",
    "unsubscribedStatus": "Nie ingeteken nie",
    "about": "Oor",
    "version": "Weergawe",
    "logout": "Teken uit",
    "logoutTitle": "Teken uit",
    "logoutConfirm": "Is jy seker jy wil uitteken?",
    "noName": "Geen naam gestel nie",
    "serverConnection": "Bedienerverbinding",
    "serverUrl": "Bediener-URL",
    "serverEdit": "Wysig",
    "saveReconnect": "Stoor en herverbind",
    "resetDefault": "Herstel na verstek",
    "invalidServerUrlTitle": "Ongeldige bediener-URL",
    "invalidServerUrlMessage": "Voer 'n geldige http of https bediener-URL in, bv. https://example.com",
    "uiLanguageChangeFailed": "Kon nie app-taal verander nie. Probeer asseblief weer.",
    "serverLanguageChangeFailed": "Kon nie geselstaal verander nie. Probeer asseblief weer.",
    "timezoneChangeFailed": "Kon nie tydsone verander nie. Probeer asseblief weer.",
    "autoSyncChangeFailed": "Kon nie outo-sinkronisering opdateer nie. Probeer asseblief weer.",
    "nameChangeFailed": "Kon nie vertoonnaam opdateer nie. Probeer asseblief weer.",
    "trialDays": "Free trial: {{daysLeft}} day(s) left",
    "trialEnds": "Trial ends {{date}}"
  },
  "reminder": {
    "body": "Herinneringsbesonderhede",
    "editTime": "Wysig tyd",
    "rename": "Hernoem",
    "snooze": "Stilmaak",
    "snooze15": "Stilmaak 15 minute",
    "pause": "Pouseer",
    "pauseReminder": "Pouseer herinnering",
    "resume": "Hervat",
    "resumeReminder": "Hervat herinnering",
    "skip": "Slaan volgende oor",
    "skipOccurrence": "Slaan hierdie keer oor",
    "syncGoogle": "Sinkroniseer met Google",
    "delete": "Verwyder",
    "deleteTitle": "Verwyder herinnering",
    "deleteConfirm": "Hierdie herinnering sal permanent verwyder word.",
    "deleteRecurringTitle": "Verwyder herhalende herinnering",
    "deleteRecurringMessage": "Wil jy hierdie keer oorslaan of die hele reeks verwyder?",
    "deleteThisOccurrence": "Slaan hierdie keer oor",
    "deleteEntireSeries": "Verwyder hele reeks",
    "done": "Gedoen",
    "markDone": "Merk as gedoen",
    "undo": "Herstel",
    "undoPrompt": "Wil dit weer aktief hê? Herstel dit nou.",
    "recurring": "Herhalend",
    "nextRun": "Volgende keer",
    "oneTime": "Eenmalig",
    "pending": "Hangende",
    "sent": "Gestuur",
    "paused": "Gepouseer",
    "active": "Aktief",
    "snoozed": "Gestil",
    "localTime": "Vertoon in jou plaaslike tyd",
    "recurrence": "Herhaling",
    "created": "Geskep",
    "tags": "Etikette",
    "fireCount": "Keer geaktiveer",
    "actions": "Aksies",
    "none": "Geen",
    "snoozeFailed": "Kon nie herinnering stilmaak nie",
    "pauseFailed": "Kon nie herinnering pouseer nie",
    "resumeFailed": "Kon nie herinnering hervat nie",
    "skipFailed": "Kon nie herinnering oorslaan nie",
    "doneFailed": "Kon nie herinnering as gedoen merk nie",
    "undoFailed": "Kon nie herinneringstatus herstel nie",
    "deleteFailed": "Kon nie herinnering verwyder nie",
    "rescheduleTitle": "Herskeduleer?",
    "rescheduleMsg": "Hierdie herinnering is agterstallig. Wil jy dit herskeduleer?",
    "reschedule15": "Oor 15 minute",
    "reschedule60": "Oor 1 uur",
    "keepOverdue": "Hou soos dit is"
  },
  "onboarding": {
    "slide1Title": "Welkom by FishMemory",
    "slide1Sub": "Jou persoonlike herinneringsassistent — aangedryf deur WhatsApp en gemaak vir jou sak.",
    "slide2Title": "Gesels natuurlik",
    "slide2Sub": "Tik herinneringe soos jy dink: \"Herinner my om môre om 15:00 vir mamma te bel\" — ons hanteer die res.",
    "slide3Title": "Mis nooit iets nie",
    "slide3Sub": "Kry betydsame kennisgewings, organiseer met etikette, en bly bo-op alles wat saak maak.",
    "getStarted": "Begin",
    "next": "Volgende",
    "firstReminderTitle": "Skep jou eerste herinnering!",
    "firstReminderHint": "Probeer iets soos:",
    "firstReminderExample": "Herinner my om môre om 9 vm water te drink",
    "gotIt": "Gekry!",
    "notifRationaleTitle": "Bly betyds",
    "notifRationaleBody": "FishMemory benodig kennisgewings om jou betyds te herinner. Jy kry net waarskuwings vir herinneringe wat jy skep.",
    "notifRationaleAllow": "Skakel kennisgewings aan",
    "notifRationaleLater": "Miskien later",
    "swipeHint": "Veeg regs vir vinnige aksies →",
    "calendarDragHint": "Sleep om uit te brei ↕"
  }
}
